/**
 * REQ-V24-016: 이슈 계층 규칙 검증 유틸리티
 *
 * 계층 구조:
 *   EPIC → STORY, BUG
 *   STORY → TASK, BUG
 *   TASK → SUB_TASK, BUG
 *   SUB_TASK → (없음)
 *   BUG → (없음)
 */

const ALLOWED_PARENT_TYPES: Record<string, string[] | null> = {
  EPIC: null,                       // EPIC은 하위 이슈가 될 수 없음
  STORY: ['EPIC'],                  // STORY의 상위는 EPIC
  TASK: ['STORY'],                  // TASK의 상위는 STORY
  SUB_TASK: ['TASK'],               // SUB_TASK의 상위는 TASK
  BUG: ['EPIC', 'STORY', 'TASK'],   // BUG는 EPIC, STORY, TASK 하위 가능
};

export function validateHierarchy(
  childType: string,
  parentType: string,
): { valid: boolean; message?: string } {
  const allowedParents = ALLOWED_PARENT_TYPES[childType];

  // EPIC은 하위 이슈가 될 수 없음
  if (allowedParents === null) {
    return { valid: false, message: 'EPIC은 하위 작업이 될 수 없습니다' };
  }

  if (!allowedParents.includes(parentType)) {
    return {
      valid: false,
      message: `${childType}의 상위는 ${allowedParents.join('/')}이어야 합니다`,
    };
  }

  return { valid: true };
}
